<div class="bolide-loader-container position-fixed top-0 end-0 bottom-0 start-0 w-100 h-100 overflow-hidden">
    <canvas ref="bolide_loader_canvas" class="d-block w-100 h-100"></canvas>
</div>
